import _taggedTemplateLiteral from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __jsx = React.createElement;
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useContext } from 'react';
import Layout from '../layouts';
import styled from 'styled-components';
import Heading from '../components/atoms/Heading';
import Para from '../components/atoms/Para';
import Anchor from '../components/atoms/Anchor';
import { Page404Labels } from '../constants/labels/en';
import breakPoints from '../themes/breakpoints';
import { SiteHeaderFragment } from '../graphql/fragments/CGQL_SiteHeader';
import { SiteHeaderOldFragment } from '../graphql/fragments/CGQL_SiteHeaderOld';
import { SiteFooterFragment } from '../graphql/fragments/CGQL_SiteFooter';
import { SiteCollectionFragment } from '../graphql/fragments/CGQL_SiteCollection';
import { Context, getYext, getYextDivision, getYextInfo, getCountryCode } from '../global-state-context';
import { dynamicStyles } from '../utils';
var WrapperDiv = styled.div.withConfig({
  componentId: "sc-1hscdy1-0"
})(["padding:40px 20px;h1,h3,p{margin-bottom:20px;}@media (min-width:", "){padding:40px 114px;}@media (min-width:", "){padding:140px 30px;h1{margin-bottom:30px;}h3,p{margin-bottom:24px;}}@media (min-width:", "){padding:140px 0;}"], breakPoints.tabletP, breakPoints.desktop, breakPoints.desktopM);
export var query = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _yield$import, gql, siteHeaderQuery, siteHeaderOldQuery, siteFooterQuery, pageQuery;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return import('@apollo/client');
          case 2:
            _yield$import = _context.sent;
            gql = _yield$import.gql;
            siteHeaderQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n    query DynamicLayoutPages($locale: String, $siteId: Int, $preview: Boolean) {\n      siteCollection(\n        where: { siteId: $siteId }\n        locale: $locale\n        preview: $preview\n      ) {\n        ...SiteHeaderFragment\n      }\n    }\n  "])), SiteHeaderFragment);
            siteHeaderOldQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  query DynamicLayoutPages($locale: String, $siteId: Int, $preview: Boolean) {\n    siteCollection(\n      where: { siteId: $siteId }\n      locale: $locale\n      preview: $preview\n    ) {\n      ...SiteHeaderOldFragment\n    }\n  }\n  "])), SiteHeaderOldFragment);
            siteFooterQuery = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n    query DynamicLayoutPages($locale: String, $siteId: Int, $preview: Boolean) {\n      siteCollection(\n        where: { siteId: $siteId }\n        locale: $locale\n        preview: $preview\n      ) {\n        ...SiteFooterFragment\n      }\n    }\n  "])), SiteFooterFragment);
            pageQuery = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  query Page404Query($locale: String, $siteId: Int, $preview: Boolean) {\n    siteCollection(\n      where: { siteId: $siteId }\n      locale: $locale\n      preview: $preview\n    ) {\n      ...SiteCollectionFragment\n    }\n  }\n"])), SiteCollectionFragment);
            return _context.abrupt("return", {
              siteHeaderQuery: siteHeaderQuery,
              siteHeaderOldQuery: siteHeaderOldQuery,
              siteFooterQuery: siteFooterQuery,
              pageQuery: pageQuery
            });
          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function query() {
    return _ref.apply(this, arguments);
  };
}();
var Page404 = function Page404(_ref2) {
  var data = _ref2.data,
    headerData = _ref2.headerData,
    footerData = _ref2.footerData;
  var _useContext = useContext(Context),
    yextContactInformationData = _useContext.yextInfo,
    storeYextInfo = _useContext.storeYextInfo;
  var siteData = (data === null || data === void 0 ? void 0 : data.siteCollection) && (data === null || data === void 0 ? void 0 : data.siteCollection.items.length) && (data === null || data === void 0 ? void 0 : data.siteCollection.items[0]) || {};
  useEffect(function () {
    if (!data) {
      return;
    }
    var mainYextId = siteData.locationContactInformation && siteData.locationContactInformation.yextIds || '';
    if ((mainYextId === null || mainYextId === void 0 ? void 0 : mainYextId.length) === 0) {
      return;
    }
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var yextInformation;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getYextInfo(mainYextId);
            case 2:
              yextInformation = _context2.sent;
              ;
              storeYextInfo(yextInformation);
            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [data]);
  if (data) {
    var pagePath = '404';
    var globalFooterData = footerData || {};
    var nvaFooterData = data.nvaComGlobalFooterCollection && data.nvaComGlobalFooterCollection.items.length && data.nvaComGlobalFooterCollection.items[0] || {};
    var contentfulAlert = data.alertCollection && data.alertCollection.items.length && data.alertCollection.items[0] || {};
    return __jsx(Layout, {
      globalHeaderData: headerData,
      nvaFooterData: nvaFooterData,
      globalFooterData: globalFooterData,
      contentfulAlertData: contentfulAlert,
      yextContactInformationData: yextContactInformationData,
      siteData: siteData,
      pageTitle: Page404Labels.PAGE_TITLE,
      pageDescription: Page404Labels.PAGE_DESCRIPTION,
      pagePath: pagePath
    }, __jsx(WrapperDiv, {
      className: "page-404 container"
    }, __jsx(Heading, {
      HeadingType: "h1"
    }, Page404Labels.HEADING), __jsx(Heading, {
      HeadingType: "h3"
    }, Page404Labels.SUB_HEADING), __jsx(Para, null, Page404Labels.DESCRIPTION), __jsx(Anchor, {
      title: Page404Labels.CTA_LABEL,
      to: "/",
      styleType: "primary-anchor",
      className: "arrow"
    }, Page404Labels.CTA_LABEL)));
  }
  return __jsx("p", null, " Loading ");
};
export function getStaticProps() {
  return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
  _getStaticProps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var _process, _process$env, _process2, _process2$env, _process3, _process3$env, _process4, _process4$env, _data$siteCollection, _data$siteCollection$, _data$siteCollection$2;
    var _yield$query, siteHeaderQuery, siteHeaderOldQuery, siteFooterQuery, pageQuery, _yield$import2, apolloClient, _yield$apolloClient$q, siteHeaderData, _yield$apolloClient$q2, siteHeaderOldData, _yield$apolloClient$q3, siteFooterData, _yield$apolloClient$q4, data, yextData, yextDivision, yextLocationCountry, headerData, referencedHeader, footerData, dynamicStylesCss;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return query();
          case 2:
            _yield$query = _context3.sent;
            siteHeaderQuery = _yield$query.siteHeaderQuery;
            siteHeaderOldQuery = _yield$query.siteHeaderOldQuery;
            siteFooterQuery = _yield$query.siteFooterQuery;
            pageQuery = _yield$query.pageQuery;
            _context3.next = 9;
            return import('../app/apollo');
          case 9:
            _yield$import2 = _context3.sent;
            apolloClient = _yield$import2.apolloClient;
            _context3.next = 13;
            return apolloClient.query({
              query: siteHeaderQuery,
              variables: {
                locale: 'en-US',
                siteId: parseInt(process.env.NEXT_PUBLIC_SITEID),
                preview: ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 13:
            _yield$apolloClient$q = _context3.sent;
            siteHeaderData = _yield$apolloClient$q.data;
            _context3.next = 17;
            return apolloClient.query({
              query: siteHeaderOldQuery,
              variables: {
                locale: 'en-US',
                siteId: parseInt(process.env.NEXT_PUBLIC_SITEID),
                preview: ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 17:
            _yield$apolloClient$q2 = _context3.sent;
            siteHeaderOldData = _yield$apolloClient$q2.data;
            _context3.next = 21;
            return apolloClient.query({
              query: siteFooterQuery,
              variables: {
                locale: 'en-US',
                siteId: parseInt(process.env.NEXT_PUBLIC_SITEID),
                preview: ((_process3 = process) === null || _process3 === void 0 ? void 0 : (_process3$env = _process3.env) === null || _process3$env === void 0 ? void 0 : _process3$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 21:
            _yield$apolloClient$q3 = _context3.sent;
            siteFooterData = _yield$apolloClient$q3.data;
            _context3.next = 25;
            return apolloClient.query({
              query: pageQuery,
              variables: {
                locale: 'en-US',
                siteId: parseInt(process.env.NEXT_PUBLIC_SITEID),
                preview: ((_process4 = process) === null || _process4 === void 0 ? void 0 : (_process4$env = _process4.env) === null || _process4$env === void 0 ? void 0 : _process4$env.NEXT_PUBLIC_ENABLE_PREVIEW) === 'true'
              },
              errorPolicy: 'ignore'
            });
          case 25:
            _yield$apolloClient$q4 = _context3.sent;
            data = _yield$apolloClient$q4.data;
            _context3.next = 29;
            return getYext({
              path: '/404',
              siteCollectionData: data
            });
          case 29:
            yextData = _context3.sent;
            yextDivision = getYextDivision(yextData);
            yextLocationCountry = getCountryCode(yextData);
            referencedHeader = data === null || data === void 0 ? void 0 : (_data$siteCollection = data.siteCollection) === null || _data$siteCollection === void 0 ? void 0 : (_data$siteCollection$ = _data$siteCollection.items) === null || _data$siteCollection$ === void 0 ? void 0 : (_data$siteCollection$2 = _data$siteCollection$[0]) === null || _data$siteCollection$2 === void 0 ? void 0 : _data$siteCollection$2.header;
            if ((referencedHeader === null || referencedHeader === void 0 ? void 0 : referencedHeader.__typename) === 'WebsiteHeaderV2') {
              headerData = siteHeaderData.siteCollection.items[0].header || {};
            } else if ((referencedHeader === null || referencedHeader === void 0 ? void 0 : referencedHeader.__typename) === 'GlobalHeader') {
              headerData = siteHeaderOldData.siteCollection.items[0].header || {};
            }
            footerData = siteFooterData.siteCollection.items[0].footer || {};
            dynamicStylesCss = dynamicStyles.generateDynamicStylesCss(data, headerData, footerData);
            return _context3.abrupt("return", {
              props: {
                data: data,
                headerData: headerData,
                footerData: footerData,
                dynamicStylesCss: dynamicStylesCss,
                dynamicStylesFontsArray: Array.from(dynamicStyles.dynamicStylesFonts),
                yextDivision: yextDivision,
                yextLocationCountry: yextLocationCountry,
                path: '/404'
              },
              revalidate: 1
            });
          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getStaticProps.apply(this, arguments);
}
export default Page404;